<script setup lang="ts">
import { useAttrs } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTooltip from '@/components/tooltips/KTooltip.vue';

defineOptions({
  inheritAttrs: false,
});

const attrs = useAttrs();
</script>

<template>
  <span>
    <KTooltip location="top" :offset="0" data-testid="openServiceDeskIconLink">
      <div>Open Service Desk</div>
      <template #activator="{ props: tooltipProps }">
        <KBtn
          :active="false"
          v-bind="{ ...tooltipProps, ...attrs }"
          :class="$style.openServiceDeskIconLink"
          variant="text"
          size="xs"
          icon="mdi-open-in-new"
          rounded="50"
        />
      </template>
    </KTooltip>
  </span>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.openServiceDeskIconLink {
}
</style>
